import { appendIf } from '@btime/helpers'
import { gql, useMutation } from '@apollo/client'
import { useSessionPermission } from '@btime/react-session'

import { cleanRequest } from './cleanRequest'
import { mergeRequestStates } from '../../../../utils/helpers/mergeRequestStates'
import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'
import { useDuplicateChecker } from '../../../../utils/hooks/duplicateServiceOrders'
import { validateFieldValues } from '../../../../utils/helpers/fields'

const MUTATION = gql`
  mutation UpsertServiceOrders($inputs: [ServiceOrderInput]) {
    upsertServiceOrders(inputs: $inputs) {
      id
    }
  }
`

const validate = (form, setErrors, hidePlace) => {
  const errors = form.reduce(
    (errors, item, index) => [
      ...errors,
      ...appendIf(!item.checklist?.id, { path: [index, 'checklist'], message: 'Campo obrigatório' }),
      ...appendIf(!hidePlace && !item.place?.id, { path: [index, 'place'], message: 'Campo obrigatório' }),
      ...validateFieldValues(form, [index, 'fieldValues'])
    ],
    []
  )

  setErrors(errors)
  return errors.length === 0
}

export const useSaveServiceOrders = () => {
  const hidePlace = useSessionPermission('hideServiceOrdersPlace')
  const closeModal = useCloseModal()
  const [checkDuplicates, findDuplicatesState] = useDuplicateChecker()

  const [request, upsertServiceOrdersState] = useMutation(MUTATION, {
    refetchQueries: ['ServiceOrders'],
    client: serviceOrdersClient
  })

  const handleRequest = async (form, actions) => {
    const inputs = cleanRequest(form)
    const { setErrors } = actions
    const isValid = validate(form, setErrors, hidePlace)

    if (isValid) {
      const [safeInputs, validateDuplicates] = await checkDuplicates(inputs)
      if (!safeInputs?.length) return

      request({ variables: { inputs: safeInputs } }).then(resp => {
        if (!resp.errors) {
          closeModal()
          validateDuplicates()
        }
      })
    }
  }

  return [handleRequest, mergeRequestStates(findDuplicatesState, upsertServiceOrdersState)]
}
